module.exports = __webpack_public_path__ + "static/media/integration-three.ff402e8a.svg";